import { useState, useEffect } from 'react';

// A custom hook to check network (internet) status based on React's custom hook architecture.

// There are two ways for detecting network changes, first using window.addEventListener('offline'/'online'),
// second, using window.ononline/window.onoffline based on my experience and tests, for an undetected reason,
// sometimes one of them not working on some components, so, I'm using this hook where is works and the other one
// where it not works.


export default function useNetwork() {
    const [isOnline, setNetwork] = useState(window.navigator.onLine);
    const updateNetwork = () => {
        setNetwork(window.navigator.onLine);
    };
    useEffect(() => {
        window.addEventListener('offline', updateNetwork);
        window.addEventListener('online', updateNetwork);
        return () => {
            window.removeEventListener('offline', updateNetwork);
            window.removeEventListener('online', updateNetwork);
        };
    });
    return isOnline;
}
